import React, { useState } from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    Paper,
} from '@mui/material';
import { RectangularSkeleton } from '../../_helpers/reusablefunctions/SkeletonCard';
import TableComponent from '../../components/Tablecomponent';
import { getDateAsPerFormat } from '../../_helpers/reusablefunctions/dateSetter';

const CreditLedger = ({ data, loading }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    if (loading) {
        return RectangularSkeleton();
    }

    const ledgerData = data?.ledger || [];

    const columnsLedger = [
        {
            id: 'created_at',
            label: 'Date',
            template: (row) => getDateAsPerFormat(row.created_at, "DD Mon, YYYY"),
        },
        // {
        //     id: 'songTitle',
        //     label: 'Song Title',
        //     template: (row) => row.song?.songTitle || '-',
        // },
        {
            id: 'remark',
            label: 'Remark',
            template: (row) => row.remark,
        },
        // {
        //     id: 'description',
        //     label: 'Description',
        //     template: (row) => row.description,
        // },
        {
            id: 'credit',
            label: 'Credits',
            template: (row) =>{
                const isNegative = String(row.credit).trim().startsWith('-');
                return(
                     <Typography variant="body2" sx={{ color: isNegative ? "#F14950" : '#008000', fontWeight: 'bold' }}>{row.credit}</Typography>
                )
            },
        },
        
        
    ];

    return (
        <Box>
            <Paper>
                {/* Total Balance Card */}
                <Box sx={{ padding: 2, display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                    <Typography variant="h6" color="text.secondary">
                        Available Coins
                    </Typography>
                    <Typography variant="h6" fontWeight="bold">
                        ({data?.total_balance})
                    </Typography>
                </Box>

                {/* Ledger Table */}
                <TableComponent
                    totalCount={ledgerData.length}
                    setRowsPerPage={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    page={page}
                    columns={columnsLedger}
                    data={ledgerData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                />
            </Paper>
        </Box>
    );
};

export default CreditLedger;
